import { FormEvent, useState } from "react";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import { Stack, TextField } from "@buildo/bento-design-system";
import { useAdminAuth } from "../../admin/AdminAuthContext";

function AdminLogin() {
  const { isAuthenticated, login } = useAdminAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [password, setPassword] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [submitting, setSubmitting] = useState(false);

  const from = (location.state as { from?: { pathname: string } } | null)?.from
    ?.pathname ?? "/admin";

  if (isAuthenticated) {
    return <Navigate to={from} replace />;
  }

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();
    setError(null);
    setSubmitting(true);
    try {
      const ok = await login(password);
      if (ok) {
        navigate(from, { replace: true });
        return;
      }
      setError("Incorrect password.");
    } catch {
      setError("Could not reach the server. Try again.");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="admin-login-page">
      <div className="admin-login-card bentolio-card">
        <h1 className="h1-text admin-login-title">PBJ Admin</h1>
        <p className="body-text admin-login-subtitle">Sign in to manage site content.</p>
        <form onSubmit={handleSubmit}>
          <Stack space={16}>
            <TextField
              label="Password"
              name="password"
              type="password"
              value={password}
              onChange={setPassword}
            />
            {error && <p className="admin-error">{error}</p>}
            <button
              type="submit"
              className="admin-btn admin-btn--primary"
              disabled={submitting}
            >
              {submitting ? "Signing in..." : "Sign in"}
            </button>
          </Stack>
        </form>
      </div>
    </div>
  );
}

export default AdminLogin;
